import { render } from "./CalcTaxRecord.vue?vue&type=template&id=b5c4be6e&scoped=true"
import script from "./CalcTaxRecord.vue?vue&type=script&lang=js"
export * from "./CalcTaxRecord.vue?vue&type=script&lang=js"

import "./CalcTaxRecord.vue?vue&type=style&index=0&id=b5c4be6e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c4be6e"]])

export default __exports__